import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IDamageReportReducer } from '../../reducers/damageReportReducer';
import { RootState } from '../../store';
import Wizard from '../wizard';
import * as StyledDamageReportForm from './damageReportForm.styles';
import DamageReportOptions from './damageReportOptions';
import FormResponseMessage from './formResponseMessage/formReponseMessage';
import StepInfo from './stepInfo';
import StepInfoAboutDamage from './stepInfoAboutDamage';
import StepPaymentInfo from './stepPaymentInfo';

interface Props {}

const DamageReportForm: FC<Props> = () => {
	const { t } = useTranslation('damageReport');
	const [chosenOption, setChosenOption] = useState('');

	const damageReportReducer: IDamageReportReducer = useSelector((store: RootState) => store.damageReportReducer);
	const { submissionFailed, submissionLoading } = damageReportReducer;

	return (
		<StyledDamageReportForm.Wrapper>
			{chosenOption.length === 0 && <DamageReportOptions selectOption={setChosenOption} />}
			{chosenOption.length > 0 && (
				<Wizard>
					<StepInfoAboutDamage name={`${t('steps.step1')}`} />
					<StepInfo name={t('steps.step2')} />
					<StepPaymentInfo name={t('steps.step3')} />
					<FormResponseMessage
						name={t('steps.step4')}
						success={!submissionFailed}
						loading={submissionLoading}
					/>
				</Wizard>
			)}
		</StyledDamageReportForm.Wrapper>
	);
};

export default DamageReportForm;
